import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { TrackedMarket } from "@/types/ApiResponses/OddsHistory";

export const getTrackedMarkets = async (
  props: QueryProps<{ lang: string }>
): Promise<{ items: TrackedMarket[] }> => {
  const res = await api.client.get("/odds-history/markets", {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
